/*
 *  Responsive Settings
 *    Settings that match the SCSS responsive settings
 *
 *
 *  Version:
 *    1.0.1 - 2019/12/01
 */
export var xsmall = 350;
export var small = 750;
export var medium = 1100;
export var large = 1350;
export var xlarge = 1650;
export var xxlarge = 2000;